/**
 * Created by neo on 04.03.17.
 */
import { makeAutoObservable } from 'mobx';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { Media, createMedia } from '../Media/Media';

export type GymType = 'gym' | 'creator' | 'coach';

export type Gym = {
  id: string;
  name: string;
  type: GymType;
  virtual: boolean;
  logo?: Media;
  medias: Media[];
  assign(athleteId?: string): Promise<any>;
};

export function createGym(json?: Partial<Gym>): Gym {
  return makeAutoObservable({
    id: json?.id || '',
    type: json?.type || 'gym',
    name: json?.name || '',
    virtual: json?.virtual ?? false,
    logo: json?.logo ? createMedia(json.logo) : undefined,
    medias: (json?.medias || []).map((m: any) => createMedia(m)),

    assign(athleteId?: string) {
      return HttpBackend.post(`/gym/customer/assign?gymId=${this.id}`, { athleteId });
    },
  });
}

export const GymApi = {
  find(page: number = 0): Promise<Gym[]> {
    return HttpBackend.get('/gym', { page }).then((data: any[]) => data.map((g) => createGym(g)));
  },

  currentGym(athleteId?: string): Promise<Gym | undefined> {
    return HttpBackend.getOrCached('gyms', '/gym/customer/recentCoachGym', { athleteId }).then((result) =>
      result ? createGym(result) : undefined,
    );
  },

  async get(id: string): Promise<Gym | undefined> {
    const data = await HttpBackend.get(`/gym/${id}`);
    return data ? createGym(data) : undefined;
  },
};
